import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import AppProviders from './app/providers/AppProviders'
import { Toaster } from 'react-hot-toast'
const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppProviders/>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: 'hsl(var(--background))',
              color: 'hsl(var(--foreground))',
              borderRadius: '8px',
              padding: '16px',
              fontSize: '14px',
              fontWeight: '500',
              boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
              zIndex: 1000,
            },
          }}
        />
    </QueryClientProvider>
  )
}

export default App